import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { calcularJanela, AVISO_MS } from 'dashboard/helper/janelaDeResposta';

// A janela de 24 h do WhatsApp oficial, viva na tela (24/09/2026).
//
// O relógio anda a cada 20 s (a contagem é em minutos) e, além dele, um alarme
// marcado para o INSTANTE em que o estado muda (entra no aviso, ou fecha): quem
// está com a conversa aberta vê a janela fechar na hora, sem recarregar. Voltar
// para a aba também acerta o relógio — o navegador segura timer de aba escondida.
export function useJanelaDeResposta(conversa, caixa) {
  const agora = ref(Date.now());
  const acertar = () => {
    agora.value = Date.now();
  };

  // A conversa diz se tem janela (não depende do cadastro de caixas guardado em
  // cache no navegador); o da caixa fica de reserva.
  const aplica = computed(
    () => !!(conversa.value?.janela_whatsapp ?? caixa.value?.is_wame)
  );
  const janela = computed(() =>
    calcularJanela({
      fechaEmServidor: conversa.value?.janela_fecha_em,
      mensagens: conversa.value?.messages,
      agora: agora.value,
    })
  );

  let relogio;
  let alarme;
  const marcarAlarme = () => {
    clearTimeout(alarme);
    const { estado, restante } = janela.value;
    if (!aplica.value || estado === 'fechada') return;
    const ate = estado === 'aberta' ? restante - AVISO_MS : restante;
    // setTimeout acima de ~24,8 dias estoura; aqui o máximo é 24 h.
    alarme = setTimeout(acertar, Math.max(ate, 0) + 250);
  };

  watch(
    () => [aplica.value, janela.value.estado, janela.value.fechaEm],
    marcarAlarme
  );

  const aoVoltar = () => document.visibilityState === 'visible' && acertar();
  onMounted(() => {
    relogio = setInterval(acertar, 20000);
    document.addEventListener('visibilitychange', aoVoltar);
    marcarAlarme();
  });
  onBeforeUnmount(() => {
    clearInterval(relogio);
    clearTimeout(alarme);
    document.removeEventListener('visibilitychange', aoVoltar);
  });

  return { aplica, janela, agora };
}
